import React from 'react';
import {Link} from "react-router-dom";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import {financial} from "v4/utils";
import useObjectToGETUrl from "v4/hooks/useObjectToGETUrl";
import {PolIcon} from "components/PolIcon/policon";

export default function DashboardQuotesSummaryCell({value, preSearch, isFinancial = false, isLoading = false, ...props}) {
    const { getRouteByNativeIdentifier } = useNavigation();
    const quotesRoute = getRouteByNativeIdentifier('main_quotes');
    const {pathname, search} = useObjectToGETUrl(`/${quotesRoute?.url}`, preSearch);

    if (isLoading) {
        return <td {...props} style={{opacity: 0.5}}><PolIcon icon="circle-notch" className="spinner"/></td>
    }

    if (!value || parseFloat(value) <= 0) {
        return <td {...props} style={isLoading ? {opacity: 0.5} : {}}>-</td>
    }

    if (preSearch) {
        return (
            <td {...props} style={isLoading ? {opacity: 0.5} : {}}>
                <Link to={{pathname, search}}>
                    {isFinancial ? financial(value) : value}
                </Link>
            </td>
        )
    }

    return <td {...props}>{isFinancial ? financial(value) : value}</td>
}
